import React, {createContext, useReducer} from "react"
import Reducer from './reducer'

const initialState = {
    price: 0,
    step: "",
    stepnumber: 0,
    stepamount: 0,
    substep: "",
    popup: null,
    choices: {},
    loading: false,
    success: false,
    scroll: 0,
    resize: 0,
    key: "",
    builder: "jacket",
    addToCartCheck: false,
    payments:[],
    numberOfPayments: 0
}

const Store = ({children}) => {
    const [state, dispatch] = useReducer(Reducer, initialState)
    return (
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
    )
}

export const Context = createContext(initialState)
export default Store